import { render } from "./AyudaAtencionReferencia.vue?vue&type=template&id=389dab6e&scoped=true"
import script from "./AyudaAtencionReferencia.vue?vue&type=script&lang=js"
export * from "./AyudaAtencionReferencia.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=389dab6e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389dab6e"]])

export default __exports__